import { render, staticRenderFns } from "./IngredientsTable.vue?vue&type=template&id=5731ab51&"
import script from "./IngredientsTable.vue?vue&type=script&lang=ts&"
export * from "./IngredientsTable.vue?vue&type=script&lang=ts&"
import style0 from "./IngredientsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports